import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { OktaAuthConfig } from './app/auth-config';
import { OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
if (environment.production) {
  enableProdMode();
}

fetch('/assets/config/app.config.json').then(async res => {
  const authConfig = await res.json();
  const oktaAuthBlock = new OktaAuthConfig(authConfig.oktaAuth);
  platformBrowserDynamic([
    { provide: OktaAuthConfig, useValue: oktaAuthBlock }
  ]).bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
